import React, { FC, ReactNode, useState } from 'react';

import { range } from '@buyside/util/lodashAlt';
import { getRandomNum } from '@buyside/util/numbers';
import { useInterval } from '@buyside/util/hooks';

import styles from '@buyside/components/presentation/Sparkle/sparklesStyles.scss';

type SparklePropType = {
  id: string;
  createdAt: number;
  size: number;
  style: { [key: string]: string };
};

const generateSparkle = (): SparklePropType => {
  return {
    id: String(getRandomNum(10000, 99999)),
    createdAt: Date.now(),
    size: getRandomNum(10, 20),
    style: {
      '--top': `${getRandomNum(-100, 100)}%`,
      '--left': `${getRandomNum(0, 100)}%`
    }
  };
};

const sparkleSvgPath =
  'M26.5 25.5C19.0043 33.3697 0 34 0 34C0 34 19.1013 35.3684 26.5 43.5C33.234 50.901 34 68 34 68C34 68 36.9884 50.7065 44.5 43.5C51.6431 36.647 68 34 68 34C68 34 51.6947 32.0939 44.5 25.5C36.5605 18.2235 34 0 34 0C34 0 33.6591 17.9837 26.5 25.5Z';

const SparkleSvg: FC<Pick<SparklePropType, 'size' | 'style'>> = ({ size, style }) => (
  <div className={styles.sparkleWrapper} style={style}>
    <svg className={styles.sparkleSvg} width={size} height={size} viewBox="0 0 68 68" fill="none">
      <path d={sparkleSvgPath} />
    </svg>
  </div>
);

const Sparkles: FC<{ children: ReactNode }> = ({ children }) => {
  const [sparkles, setSparkles] = useState(() => range([3]).map(() => generateSparkle()));

  useInterval(
    () => {
      const sparkle = generateSparkle();
      const now = Date.now();
      // Clean up any "expired" sparkles
      const nextSparkles = sparkles.filter(sparkle => now - sparkle.createdAt < 1000);
      nextSparkles.push(sparkle);
      setSparkles(nextSparkles);
    },
    50,
    500
  );

  return (
    <span className={styles.wrapper}>
      {sparkles.map(sparkle => (
        <SparkleSvg key={sparkle.id} size={sparkle.size} style={sparkle.style} />
      ))}
      <div className={styles.childWrapper}>{children}</div>
    </span>
  );
};

export default Sparkles;
